module.exports = __webpack_public_path__ + "img/dark-green-booth-table-6.47b0690d.png";